import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const query = graphql`
    {
        file(relativePath: {eq: "logo.png"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`

const Background = () => {
  const { file: { childImageSharp: { fluid } } } = useStaticQuery(query)
  return (
    <header>
      <BackgroundImage Tag='div' fluid={fluid} className='hero' />
    </header>
  )
}

export default Background
